export default "__VITE_ASSET__vyX32cAY__"